import {
  Message
} from 'element-ui'
import {
  setStore,
  getStore
} from '@/util/store'
import {
  validatenull
} from '@/util/validate'
import {
  login,
  getUserInfo,
  logout
} from '@/api/api'

const user = {
  state: {
    userInfo: getStore({
      name: 'userInfo'
    }) || {},
    isLogin: getStore({
      name: 'isLogin'
    }) || 0,
    isChecked: getStore({
      name: 'isChecked'
    }) || false,
    email: getStore({
      name: 'email'
    }) || '',
    token: '',
    operationCenterToken: '' // 运维中心token
  },
  actions: {},
  mutations: {
    // 存用户信息
    SET_USER_INFO: (state, userInfo) => {
      // console.log(state, userInfo, 'SET_USER_INFO')
      if (validatenull(userInfo.avatar)) {
        userInfo.avatar = "";
        // userInfo.avatar = "/img/bg/img-logo.png";
      }
      state.userInfo = userInfo;
      setStore({
        name: 'userInfo',
        content: state.userInfo
      })
    },

    // 登录状态
    SET_LOGIN: (state, isLogin) => {
      console.log(state, isLogin, 'SET_LOGIN')
      state.isLogin = isLogin;
      setStore({
        name: 'isLogin',
        content: state.isLogin
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js